import React, {useContext, Fragment} from 'react'
import {Link} from 'react-router-dom'
import farmerContext from '../../../context/farmer/farmerContext'

const ManageFarmTableRow = ({farm}) => {


    const FarmerContext = useContext(farmerContext);


    const {deleteFarm} = FarmerContext;

    const {id, farm_name, farm_type, state, lga, address} = farm;

    const onDelete = farm_id => {
        deleteFarm(farm_id)
    }

    return (
        <Fragment>

            <td>{farm_name}</td>
            <td>{farm_type.name}</td>
            <td>{state.name}</td>
            <td>{lga.name}</td>
            <td>{address}</td>
            <td className="button-container">
                <Link to={"/farmer/farm/manage/edit/" + id} type="button"
                      className="btn btn-sm button_style btn-inverse-primary mr-2 waves-effect waves-light">EDIT</Link>
                <button type="button" onClick={() => onDelete(id)}
                        className="btn btn-sm button_style btn-inverse-danger waves-effect waves-light">DELETE
                </button>
            </td>


        </Fragment>
    )
}

export default ManageFarmTableRow
